import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';

import Home from './pages/Home';
import Footer from './components/Footer';
import SiteNavbar from './components/Navbar';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import AdminDashboard from "./pages/AdminDashboard";
import UserDashboard from './pages/UserDashboard';
import ServicesPage from './pages/ServicesPage';
import TechNewsPage from './pages/TechNewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import AdminNewsPage from './pages/AdminNewsPage';

import AboutPage from "./pages/AboutPage";

import AdminDashboardUser from './pages/AdminDashboardUser';
import AdminDashboardNews from './pages/AdminDashboardNews';
import AdminDashboardSettings from './pages/AdminDashboardSettings';
import AdminDashboardCategories from './pages/AdminDashboardCategories'; 

import TechVideosPage from './pages/TechVideosPage';
import AdminDashboardVideos from './pages/AdminDashboardVideos';
import AdminDashboardVideoCategories from './pages/AdminDashboardVideoCategories';


import PublicationPage from './pages/PublicationPage';
import AdminDashboardPublication from './pages/AdminDashboardPublication';
import AdminDashboardPublicationCategories from './pages/AdminDashboardPublicationCategories';


import ProjectsPage from './pages/ProjectsPage'; 
import AdminDashboardProjects from './pages/AdminDashboardProjects';

import ProjectDetailPage from './pages/ProjectDetailPage';


function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="container py-5">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requiredRole && user.role !== requiredRole) return <Navigate to="/dashboard" replace />;
  return children;
}

// پس از Google OAuth، بر اساس نقش به مسیر درست هدایت می‌کنیم
function PostOAuthRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="container py-5">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return user.role === 'admin' ? <Navigate to="/admin" replace /> : <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <Router>
      <div className="App">
        <SiteNavbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/redirect" element={<PostOAuthRedirect />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/technews" element={<TechNewsPage />} />
          <Route path="/news/:id" element={<NewsDetailPage />} />
          <Route path="/admin/news" element={<AdminNewsPage />} />
          <Route path="/admin/dashboard/categories" element={<AdminDashboardCategories />} />
          <Route path="/videos" element={<TechVideosPage />} />
          <Route path="/projects/:id" element={<ProjectDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          
           <Route path="/admin/dashboard/users" element={
            <ProtectedRoute requiredRole="admin">
              <AdminDashboardUser />
            </ProtectedRoute>
          } />

          <Route path="/admin/dashboard/news" element={
            <ProtectedRoute requiredRole="admin">
              <AdminDashboardNews />
            </ProtectedRoute>
          } />

          <Route path="/admin/dashboard/settings" element={
            <ProtectedRoute requiredRole="admin">
              <AdminDashboardSettings />
            </ProtectedRoute>
          } />




          <Route path="/dashboard" element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          } />

          <Route path="/admin" element={
            <ProtectedRoute requiredRole="admin">
              <AdminDashboard />
            </ProtectedRoute>
          } />

          {/* fallback به صفحه اصلی */}
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/admin/dashboard/videos" element={<AdminDashboardVideos />} />
          <Route path="/admin/dashboard/video-categories" element={<AdminDashboardVideoCategories />} />

          <Route path="/publications" element={<PublicationPage />} />
          <Route path="/admin/dashboard/publications" element={<AdminDashboardPublication />} />
          <Route path="/admin/dashboard/publication-categories" element={<AdminDashboardPublicationCategories />} />
          

          <Route path="/projects" element={<ProjectsPage />} />

          <Route path="/admin/dashboard/projects" element={
                <ProtectedRoute requiredRole="admin">
                      <AdminDashboardProjects />
                </ProtectedRoute>
            } />



        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
